<template>
    <div>
        <div
            class="interest-container w-full flex-layout-v flex-justify-space"
            v-if="!apiIsLoading"
        >
            <div class="interest-container-top w-full">
                <div
                    class="interest-container-top-pics"
                    v-if="detailData.imageList && detailData.imageList.length > 0"
                >
                    <van-swipe :autoplay="10000" width="340" height="200" @change="swipeChange">
                        <div class="flex-layout-h">
                            <van-swipe-item
                                class="pic-swipe-item"
                                v-for="(item, index) in detailData.imageList"
                            >
                                <div
                                    class="pic-swipe-item-img"
                                    :style="{
                                        backgroundImage: 'url(' + item + ')',
                                    }"
                                ></div>
                            </van-swipe-item>
                        </div>

                        <!-- 自定义轮播图指示器 -->
                        <template #indicator v-if="detailData.imageList.length >= 2">
                            <div class="custom-indicator">
                                <span
                                    v-for="(item, index) in detailData.imageList"
                                    :class="swipeIndex == index ? 'indicator_activity' : ''"
                                ></span>
                            </div>
                        </template>
                    </van-swipe>
                </div>
                <div v-else class="interest-container-top-placeholder"></div>
                <div class="interest-container-top-title">
                    {{ detailData.awardName }}
                </div>
            </div>
            <div class="interest-container-center w-full"></div>
            <div class="interest-container-bottom w-full">
                <div class="interest-container-bottom-title">领取有效期</div>
                <div class="interest-container-bottom-date">
                    {{ detailData.validEndDate | dateFormat('LLL') }}前可领取
                </div>
                <div class="interest-container-bottom-subtitle">权益领取说明</div>
                <div class="interest-container-bottom-desc" v-html="detailData.desc"></div>
            </div>
            <div class="interest-container-btn w-full flex-layout-v flex-item-center">
                <div
                    class="interest-container-btn-content text-layout-center"
                    v-if="detailData.awardStatus === 10"
                    @click="awardClick()"
                >
                    免费领取
                </div>
                <div
                    class="interest-container-btn-content interest-container-btn-contentopacity text-layout-center"
                    v-else-if="detailData.awardStatus === 0"
                    @click="awardClick()"
                >
                    {{ detailData.requiredScore }}活力值专享
                </div>
                <div
                    class="interest-container-btn-content interest-container-btn-contentopacity text-layout-center"
                    v-else-if="detailData.awardStatus === 20"
                    @click="awardClick()"
                >
                    已领取
                </div>
            </div>
        </div>
        <AwardDialog
            :show="showAwardDialog"
            :content="awardDialogContent"
            @onClickHide="onClickHide"
        />
        <Dialog
            :show="showOverdueDialog"
            title="对不起，您当前存在逾期，请先完成还款。"
            lefttxt="再看看"
            righttxt="去还款"
            @giveupBtn="giveupToRepay"
            @continueBtn="doSomeRepay"
        />
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';
// import { mapState } from 'vuex';
import Dialog from '../../componets/birthday/homeDialog';
import AwardDialog from '../../componets/interests_detail/dialog';
export default {
    components: { AwardDialog, Dialog },
    mixins: [homemixin],
    data() {
        return {
            swipeIndex: 0,
            key: '',
            showAwardDialog: false,
            awardDialogContent: {},
            isOldCustomer: false,
            apiIsLoading: false,
            showOverdueDialog: false,
            totalScore: localStorage.getItem('KUserTotalScore'),
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose,
                    },
                ],
                titleView: {
                    text: '生活权益详情',
                    color: '#000000',
                },
                rightView: [],
            },
            detailData: {},
        };
    },
    watch: {
        showAwardDialog(n, o) {
            if (n) {
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_inclusive_box',
                    tgt_name: 'h5-ACT-普惠权益详情页-弹窗',
                    page: 'super-普惠权益详情页',
                    param: `${this.currentScore}`,
                });
            }
        },
    },
    computed: {
        // ...mapState('home', ['isOldCustomer'])
    },
    mounted() {
        this.parseLocalStroage();
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
        this.key = this.$route.query.key;
        this.getbenefitdetailData();
        this.requestReceiveAwardApi = this.debounce(() => {
            this.receiveAward();
        }, 500);
    },
    methods: {
        HTMLDecode(text) {
            var temp = document.createElement('div');
            temp.innerHTML = text;
            var output = temp.innerText || temp.textContent;
            temp = null;
            return output;
        },
        UrlParamHash() {
            let valueUrl = this.detailData.desc;
            var UrlArr = valueUrl.match(
                /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\;\&\#\!\/\\\w]*))?)/
            );
            if (UrlArr) {
                let encodeUrl = this.HTMLDecode(UrlArr[0]);
                this.awardDialogContent.link = encodeUrl;
                // console.log('url-param', UrlArr[0], encodeUrl);
            }
        },
        awardClick() {
            if (this.detailData.awardStatus === 20 || this.detailData.awardStatus === 0) {
                // this.$toast('不满足兑换条件');
                return;
            }
            if (this.detailData.awardStatus === 10) {
                this.requestReceiveAwardApi();
            }
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_inclusive',
                tgt_name: 'h5-ACT-普惠权益详情页',
                page: 'super-普惠权益详情页',
                param: `${this.currentScore}`,
                param1:
                    this.detailData.awardStatus === 10
                        ? '免费领取'
                        : this.detailData.awardStatus === 0
                        ? `${this.detailData.requiredScore}活力值专享`
                        : this.detailData.awardStatus === 20
                        ? '已领取'
                        : '',
            });
        },
        // 自定义轮播指示器
        swipeChange(index) {
            this.swipeIndex = index;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_inclusive',
                tgt_name: 'h5-ACT-普惠权益详情页',
                page: 'super-普惠权益详情页',
                param: `${this.currentScore}`,
                param1: '滑动图片',
            });
        },
        async getbenefitdetailData() {
            try {
                this.apiIsLoading = true;
                const { Result, Content, ResultMessage } = await this.$http.getbenefitdetail({
                    key: this.key,
                });
                if (Result === 200) {
                    this.detailData = Content;
                } else {
                    if (Result === 40716) {
                        this.$toast(ResultMessage);
                        // this.goClose();
                    }
                    this.POINT('h5_auth', {
                        auth_tgt: 'super_privilege_errorMsg',
                        auth_tgt_name: 'super-成长权益-报错集合',
                        page: 'super-普惠权益列表',
                        ret_code: Result,
                        param: ResultMessage,
                        param1: '/growth/duiba/getbenefitdetail',
                    });
                }
            } catch (error) {
            } finally {
                this.apiIsLoading = false;
            }
        },
        async receiveAward() {
            const { Result, Content, ResultMessage } = await this.$http.receive({ key: this.key });
            if (Result === 200) {
                if (!Content.password && !Content.account && !Content.code) {
                    if (Content.link && Content.link.length > 0) {
                        location.href = Content.link;
                    } else {
                        this.UrlParamHash();
                        location.href = this.awardDialogContent.link;
                    }
                    return;
                }
                this.showAwardDialog = true;
                this.awardDialogContent = Content;
                if (!Content.link) {
                    this.UrlParamHash();
                }
                console.log('link-url', Content, this.awardDialogContent);
                this.getbenefitdetailData();
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_inclusive',
                    tgt_name: 'h5-ACT-普惠权益详情页',
                    page: 'super-普惠权益详情页',
                    param: `${this.currentScore}`,
                    param2: this.detailData.awardName,
                    param3: this.detailData.key,
                    param4: this.detailData.type,
                    param5:
                        this.detailData.awardStatus === 10
                            ? '免费领取'
                            : this.detailData.awardStatus === 0
                            ? `${this.detailData.requiredScore}活力值专享`
                            : this.detailData.awardStatus === 20
                            ? '已领取'
                            : '',
                });
            } else if (Result === 40719) {
                this.showOverdueDialog = true;
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_inclusive_yuqibox',
                    tgt_name: 'h5-ACT-普惠权益详情页-逾期提示弹窗',
                    page: 'super-普惠权益详情页',
                    param: this.currentScore,
                });
            } else {
                this.$toast(ResultMessage);
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_inclusive_toast',
                    tgt_name: 'h5-ACT-普惠权益详情页-toast',
                    page: 'super-普惠权益详情页',
                    param: ResultMessage,
                });

                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-普惠权益详情页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/duiba/receive',
                });
            }
        },
        giveupToRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_inclusive_yuqibox',
                tgt_name: 'h5-ACT-普惠权益详情页-逾期提示弹窗',
                page: 'super-普惠权益详情页',
                param: this.totalScore,
                param1: '再看看',
            });
        },
        doSomeRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_inclusive_yuqibox',
                tgt_name: 'h5-ACT-普惠权益详情页-逾期提示弹窗',
                page: 'super-普惠权益详情页',
                param: this.totalScore,
                param1: '去还款',
            });
            this.openLink('ppdloanapp://repayment/index');
        },
        onClickHide() {
            this.showAwardDialog = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';

.interest-container {
    &-top {
        background: white;
        padding: 6px 18px;
        &-pics {
            width: 340px;
            overflow: hidden;
            height: 200px;
            position: relative;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 1px 8px 0px rgba(186, 201, 207, 0.32);
            border-radius: 6px;
            .custom-indicator {
                position: absolute;
                bottom: 9px;
                display: flex;
                justify-content: center;
                margin: 0 auto;
                left: 45%;
                span {
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: #9faab5;
                    margin: 0 2px;
                }
                .indicator_activity {
                    border-radius: 50%;
                    background: rgba(255, 129, 67, 1) !important;
                }
            }
        }
        &-placeholder {
            .backgroundImage(340px, 200px, '~@assets/img/interests_placeholder.png');
        }
        .pic-swipe {
            &-item {
                width: 340px;
                height: 200px;
                border-radius: 6px;
                &-img {
                    width: 340px;
                    height: 200px;
                    border-radius: 6px;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center center;
                }
            }
        }
        &-title {
            .f-16-bold();
            color: #002a3c;
            width: 339px;
            margin-top: 16px;
            margin-bottom: 16px;
        }
    }
    &-center {
        background: rgba(245, 248, 250, 1);
        height: 6px;
    }
    &-bottom {
        padding: 18px;
        background: white;
        margin-bottom: 78px;
        &-title {
            color: #002a3c;
            .f-14();
        }
        &-date {
            color: #9faab5;
            margin-top: 12px;
            .f-12();
        }
        &-subtitle {
            color: #002a3c;
            margin-top: 18px;

            .f-14();
        }

        &-desc {
            margin-top: 11px;
            color: #49596c;
            .f-12();
            line-height: 20px;
        }
    }
    &-btn {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        padding: 12px 0;
        background: white;
        &-content {
            width: 343px;
            height: 46px;
            background: rgba(255, 129, 67, 1);
            border-radius: 8px;
            .f-18-bold();
            color: #ffffff;
            line-height: 46px;
        }
        &-contentopacity {
            opacity: 0.4;
        }
    }
}
</style>
